module.exports = __webpack_public_path__ + "static/media/0.91123cad.mp3";